import React from "react";

const SalesIcon = () => {
  return (
<svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7 5.66667V13M12 2V13M2 9.33333V13" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

  );
};

export default SalesIcon;
